// Fixed PST, deliberately no daylight-saving conversion.
export const PST_ZONE = 'Etc/GMT+8';
export function pstDay(instant: string | Date): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: PST_ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
  }).format(new Date(instant));
}
export function pstTime(instant: string): string {
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: PST_ZONE, hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).format(new Date(instant));
}
export function dayDate(day: string): Date { return new Date(`${day}T12:00:00Z`); }
export function addDays(day: string, amount: number): string {
  const date = dayDate(day);
  date.setUTCDate(date.getUTCDate() + amount);
  return date.toISOString().slice(0, 10);
}
export function weekStart(day: string): string {
  return addDays(day, -dayDate(day).getUTCDay());
}
export function weekGrid(start: string): string[] {
  return Array.from({ length: 28 }, (_, i) => addDays(start, i));
}
export function dateLabel(day: string): string {
  return dayDate(day).toLocaleDateString('en-US', { timeZone: 'UTC', weekday: 'long', month: 'long', day: 'numeric' });
}
export function timeLabel(time: string): string {
  return new Date(`2000-01-01T${time}:00-08:00`).toLocaleTimeString('en-US', {
    timeZone: PST_ZONE, hour: 'numeric', minute: '2-digit',
  });
}
export function postingInstant(day: string, time: string): number {
  return new Date(`${day}T${time}:00-08:00`).getTime();
}
